<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`video`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="400"
  >
    <card class="text-center">
        <fg-input type="text" :label="`link_video`"   v-model="value" />
      <br/>
      <button @click="accept" class="btn btn-sm btn-success mr-2">     {{'add' | setText('Добавить')}}</button>
      <button @click="$modal.hide('video')" class="btn btn-sm btn-danger">     {{'cancel' | setText('Отмена')}}</button>
    </card>

  </modal>
</template>
<script>

export default {
  name: "ListItem",
  data() {
    return {
      value:'https://www.youtube.com/embed/'
    };
  },
  methods: {
    modalClose() {

    },
    modalOpen() {
        this.value = 'https://www.youtube.com/embed/'
    },
    accept() {
      this.$emit('input',this.value);
      this.value = 'https://www.youtube.com/embed/'
      this.$modal.hide('video');
    },
  },
};
</script>